module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('md-card', [_c('md-card-content', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color md-theme-default back heght-1px",
    on: {
      "click": _vm.previousFFView
    }
  }, [_vm._v("« Back")])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('h2', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Sales Booking")])])], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('label', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('u', [_vm._v("Job Type")])])]), _vm._v(" "), _vm._l((_vm.showSegmentArray), function(segmentNameArray, index) {
    return _c('md-layout', {
      key: index,
      attrs: {
        "md-flex": segmentNameArray.flex
      }
    }, [_c('md-checkbox', {
      staticClass: "md-primary",
      attrs: {
        "md-value": segmentNameArray.value,
        "name": 'jobType' + (index + 1),
        "id": 'jobType' + (index + 1),
        "disabled": _vm.ffExoprtDetail.allModuleId != '' ? true : false
      },
      on: {
        "change": function($event) {
          _vm.jobTypeSelect(segmentNameArray.value, index)
        }
      },
      model: {
        value: (_vm.ffExoprtDetail.jobType[index]),
        callback: function($$v) {
          _vm.$set(_vm.ffExoprtDetail.jobType, index, $$v)
        },
        expression: "ffExoprtDetail.jobType[index]"
      }
    }, [_vm._v(_vm._s(segmentNameArray.show))])], 1)
  })], 2), _vm._v(" "), _c('hr', {
    staticClass: "hr-border"
  }), _vm._v(" "), (_vm.newJobType.length > 0) ? _c('div', [_c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "transportType"
    }
  }, [_vm._v("Export / Import")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.transportTypeList,
      "option-value": "transportTypeVal",
      "option-text": "transportTypeText",
      "placeholder": "Select Type"
    },
    model: {
      value: (_vm.ffExoprtDetail.transportType),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "transportType", $$v)
      },
      expression: "ffExoprtDetail.transportType"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.transportType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.transportTypeError))]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.newJobType.indexOf('TPT') >= 0) ? _c('div', [_c('hr', {
    staticClass: "hr-bodr"
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Client Name (Transportation)")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.clientList,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Existing Client Name"
    },
    model: {
      value: (_vm.ffExoprtDetail.clientId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "clientId", $$v)
      },
      expression: "ffExoprtDetail.clientId"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.clientId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.clientIdError))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "AutoPickupLocation"
    }
  }, [_vm._v("Pickup Location (Transportation)")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.allLocationList,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Pickup Location"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'getAlllocationListData')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'getAlllocationListData')
      }
    },
    model: {
      value: (_vm.ffExoprtDetail.pickupLocationId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "pickupLocationId", $$v)
      },
      expression: "ffExoprtDetail.pickupLocationId"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.pickupLocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.pickupLocationIdError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "AutoStuffingLocation"
    }
  }, [_vm._v("Factory Location (Transportation)1")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.tempfactoryDetail,
      "option-value": "location",
      "option-text": "factoryTitle",
      "isDisabled": _vm.ffExoprtDetail.clientId == '' ? true : false,
      "placeholder": _vm.factoryDetail.length > 0 ? 'Select Factory Location' : 'No Factory'
    },
    model: {
      value: (_vm.ffExoprtDetail.stuffingLocationId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "stuffingLocationId", $$v)
      },
      expression: "ffExoprtDetail.stuffingLocationId"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.stuffingLocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.stuffingLocationIdError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "AutoHandoverLocation"
    }
  }, [_vm._v("Handover Location (Transportation)")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.getAlllocationHandover,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Handover Location"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'getAlllocationHandover')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'getAlllocationHandover')
      }
    },
    model: {
      value: (_vm.ffExoprtDetail.handoverLocationId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "handoverLocationId", $$v)
      },
      expression: "ffExoprtDetail.handoverLocationId"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.handoverLocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.handoverLocationIdError))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "containerTypeId"
    }
  }, [_vm._v("Container Type/Size (Transportation)")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.ContainerTypeList,
      "option-value": "containerTypeId",
      "option-text": "containerType",
      "placeholder": "Select Container Type/Size"
    },
    model: {
      value: (_vm.ffExoprtDetail.transContainerTypeId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "transContainerTypeId", $$v)
      },
      expression: "ffExoprtDetail.transContainerTypeId"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.transContainerTypeId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.transContainerTypeIdError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "noOfContainer"
    }
  }, [_vm._v("No. of Containers")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "noOfContainer",
      "name": "noOfContainer",
      "type": "number"
    },
    model: {
      value: (_vm.ffExoprtDetail.noOfContainer),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "noOfContainer", $$v)
      },
      expression: "ffExoprtDetail.noOfContainer"
    }
  })], 1)], 1)], 1), _vm._v(" "), ((_vm.newJobType.indexOf('FF') >= 0 && _vm.newJobType.indexOf('TPT') >= 0)) ? _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('label', {
    attrs: {
      "for": "ccType"
    }
  }, [_vm._v("TPT Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.cctypeList,
      "option-value": "ccTypeVal",
      "option-text": "ccTypeTxt",
      "placeholder": "Select TPT Type"
    },
    model: {
      value: (_vm.ffExoprtDetail.tptType),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "tptType", $$v)
      },
      expression: "ffExoprtDetail.tptType"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.ffExoprtDetail.tptType == '2') ? _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Transporter Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "transporterName",
      "name": "transporterName"
    },
    model: {
      value: (_vm.ffExoprtDetail.transporterName),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "transporterName", $$v)
      },
      expression: "ffExoprtDetail.transporterName"
    }
  })], 1)], 1) : _vm._e()], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.newJobType.indexOf('FF') >= 0 || _vm.newJobType.indexOf('CC') >= 0) ? _c('div', [_c('hr', {
    staticClass: "hr-bodr"
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('label', {
    attrs: {
      "for": "containerInfo"
    }
  }, [_vm._v("FF Activity Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.containerInfoList,
      "option-value": "containerInfoVal",
      "option-text": "containerInfoText",
      "placeholder": "Select Activity Type"
    },
    model: {
      value: (_vm.ffExoprtDetail.containerInfo),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "containerInfo", $$v)
      },
      expression: "ffExoprtDetail.containerInfo"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.containerInfo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.containerInfoError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('label', {
    attrs: {
      "for": "shipmentType"
    }
  }, [_vm._v("Shipping Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": "",
      "list": _vm.shipmentTypeList,
      "option-value": "shipmentTypeVal",
      "option-text": "shipmentTypeText",
      "placeholder": "Select Shipment Type"
    },
    model: {
      value: (_vm.ffExoprtDetail.shipmentType),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "shipmentType", $$v)
      },
      expression: "ffExoprtDetail.shipmentType"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.shipmentType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.shipmentTypeError))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Importer Name (Freight)")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.clientList,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Importer Name"
    },
    model: {
      value: (_vm.ffExoprtDetail.importerClientId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "importerClientId", $$v)
      },
      expression: "ffExoprtDetail.importerClientId"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.importerClientId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.importerClientIdError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Exporter Name (Freight)")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.clientList,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Exporter Name"
    },
    model: {
      value: (_vm.ffExoprtDetail.exporterClientId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "exporterClientId", $$v)
      },
      expression: "ffExoprtDetail.exporterClientId"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.exporterClientId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.exporterClientIdError))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('label', {
    attrs: {
      "for": "stuffingType"
    }
  }, [_vm._v("Stuffing Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.stuffingTypeList,
      "option-value": "stuffingTypeVal",
      "option-text": "stuffingTypeText",
      "placeholder": "Select Stuffing Type",
      "isDisabled": _vm.ffExoprtDetail.containerInfo != 'fcl' ? true : false
    },
    model: {
      value: (_vm.ffExoprtDetail.stuffingType),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "stuffingType", $$v)
      },
      expression: "ffExoprtDetail.stuffingType"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.stuffingType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.stuffingTypeError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('label', {
    attrs: {
      "for": "shippingId"
    }
  }, [_vm._v("Shipping Line Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.shippingList,
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line"
    },
    model: {
      value: (_vm.ffExoprtDetail.shippingId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "shippingId", $$v)
      },
      expression: "ffExoprtDetail.shippingId"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.shippingId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.shippingIdError))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('label', {
    attrs: {
      "for": "PORlocationId"
    }
  }, [_vm._v("Place of Receipt (Freight)")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.IcdPOrtList,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Place of Receipt"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'Icd,Sea_Port', 'IcdPOrtList')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'Icd,Sea_Port', 'IcdPOrtList')
      }
    },
    model: {
      value: (_vm.ffExoprtDetail.PORlocationId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "PORlocationId", $$v)
      },
      expression: "ffExoprtDetail.PORlocationId"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.PORlocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.PORlocationIdError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('label', {
    attrs: {
      "for": "LPlocationId"
    }
  }, [_vm._v("Load Port Name (Freight)")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.PortLoadList,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Load Port Name",
      "isDisabled": _vm.ffExoprtDetail.portType != 'Icd' ? true : false,
      "isError": _vm.ffExoprtDetail.portType != 'Icd' ? true : false
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'Sea_Port', 'PortLoadList')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'Sea_Port', 'PortLoadList')
      }
    },
    model: {
      value: (_vm.ffExoprtDetail.LPlocationId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "LPlocationId", $$v)
      },
      expression: "ffExoprtDetail.LPlocationId"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.LPlocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.LPlocationIdError))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('label', {
    attrs: {
      "for": "PODLocationId"
    }
  }, [_vm._v("Port of Discharge (Freight)")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.PortDischargeList,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select POD"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'Sea_Port', 'getPortDischargeList')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'Sea_Port', 'getPortDischargeList')
      }
    },
    model: {
      value: (_vm.ffExoprtDetail.PODLocationId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "PODLocationId", $$v)
      },
      expression: "ffExoprtDetail.PODLocationId"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.PODLocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.PODLocationIdError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('label', {
    attrs: {
      "for": "finalPlaceLocationId"
    }
  }, [_vm._v("Final Place of Delivery (Freight)")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.finalAllPlaceData,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select FPOD"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceData')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceData')
      }
    },
    model: {
      value: (_vm.ffExoprtDetail.finalPlaceLocationId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "finalPlaceLocationId", $$v)
      },
      expression: "ffExoprtDetail.finalPlaceLocationId"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.finalPlaceLocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.finalPlaceLocationIdError))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('label', {
    attrs: {
      "for": "deliveryMode"
    }
  }, [_vm._v("Destination Delivery Mode")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.deliveryModeList,
      "option-value": "deliveryModeVal",
      "option-text": "deliveryModeText",
      "placeholder": "Select Delivery Mode"
    },
    model: {
      value: (_vm.ffExoprtDetail.deliveryMode),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "deliveryMode", $$v)
      },
      expression: "ffExoprtDetail.deliveryMode"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('label', {
    attrs: {
      "for": "deliveryTerms"
    }
  }, [_vm._v("Delivery Terms(INCOTERMS)")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.deliveryTermsList,
      "option-value": "deliveryTermsVal",
      "option-text": "deliveryTermsText",
      "placeholder": "Select Delivery Terms"
    },
    model: {
      value: (_vm.ffExoprtDetail.deliveryTerms),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "deliveryTerms", $$v)
      },
      expression: "ffExoprtDetail.deliveryTerms"
    }
  })], 1)], 1), _vm._v(" "), ((_vm.newJobType.indexOf('FF') >= 0 && _vm.newJobType.indexOf('CC') >= 0)) ? _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('label', {
    attrs: {
      "for": "ccType"
    }
  }, [_vm._v("CC Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.cctypeList,
      "option-value": "ccTypeVal",
      "option-text": "ccTypeTxt",
      "placeholder": "Select CC Type"
    },
    model: {
      value: (_vm.ffExoprtDetail.ccType),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "ccType", $$v)
      },
      expression: "ffExoprtDetail.ccType"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.ffExoprtDetail.ccType == '2') ? _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("CHA Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "ccCha",
      "name": "ccCha"
    },
    model: {
      value: (_vm.ffExoprtDetail.ccCha),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "ccCha", $$v)
      },
      expression: "ffExoprtDetail.ccCha"
    }
  })], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Remarks")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "remark",
      "name": "remark"
    },
    model: {
      value: (_vm.ffExoprtDetail.remark),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "remark", $$v)
      },
      expression: "ffExoprtDetail.remark"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-border"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.newJobType.indexOf('CC') >= 0 || _vm.newJobType.indexOf('FF') >= 0) ? _c('div', [_c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "autoCommodity"
    }
  }, [_vm._v("Commodity")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.commodityList,
      "option-value": "commodityId",
      "option-text": "itemDescription",
      "placeholder": "Select Commodity"
    },
    model: {
      value: (_vm.CommodityAll),
      callback: function($$v) {
        _vm.CommodityAll = $$v
      },
      expression: "CommodityAll"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.commodityType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.commodityTypeError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "commodityType"
    }
  }, [_vm._v("Commodity Type")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "commodityType",
      "name": "commodityType",
      "disabled": ""
    },
    model: {
      value: (_vm.ffExoprtDetail.commodityType),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "commodityType", $$v)
      },
      expression: "ffExoprtDetail.commodityType"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "itemDescription"
    }
  }, [_vm._v("Item Description")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "itemDescription",
      "name": "itemDescription",
      "disabled": ""
    },
    model: {
      value: (_vm.ffExoprtDetail.itemDescription),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "itemDescription", $$v)
      },
      expression: "ffExoprtDetail.itemDescription"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.ffExoprtDetail.commodityType == 'Hazardous') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("IMDG Class")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "IMDGClass",
      "name": "IMDGClass"
    },
    model: {
      value: (_vm.ffExoprtDetail.IMDGClass),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "IMDGClass", $$v)
      },
      expression: "ffExoprtDetail.IMDGClass"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("UN Number")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "UNNumber",
      "name": "UNNumber"
    },
    model: {
      value: (_vm.ffExoprtDetail.UNNumber),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "UNNumber", $$v)
      },
      expression: "ffExoprtDetail.UNNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Packing Code")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "packingCode",
      "name": "packingCode"
    },
    model: {
      value: (_vm.ffExoprtDetail.packingCode),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "packingCode", $$v)
      },
      expression: "ffExoprtDetail.packingCode"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.ffExoprtDetail.commodityType == 'Reefer') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Temperature Req(Degree Celsius)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "temperatureRequired",
      "name": "temperatureRequired"
    },
    model: {
      value: (_vm.ffExoprtDetail.temperatureRequired),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "temperatureRequired", $$v)
      },
      expression: "ffExoprtDetail.temperatureRequired"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.ffExoprtDetail.commodityType == 'Others') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Specific Detail if any..!")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "otherComodity",
      "name": "otherComodity"
    },
    model: {
      value: (_vm.ffExoprtDetail.otherComodity),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "otherComodity", $$v)
      },
      expression: "ffExoprtDetail.otherComodity"
    }
  })], 1)], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "hr-border"
  }), _vm._v(" "), (_vm.allModuleIdNew == '' || _vm.allModuleIdNew == null) ? _c('md-layout', {
    staticClass: "mrgtop-button",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary md-button-color heght-1px mrgtop-2per",
    attrs: {
      "id": "addButtonLoader"
    },
    on: {
      "click": _vm.addFFExport
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1) : _vm._e()], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseAddFF
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f6f3869","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/allModuleForm/allModuleForm.vue
// module id = 2440
// module chunks = 0